import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const PlayButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 69 69" fill="none">
    <circle cx="34.2143" cy="34.2143" r="34.2143" fill="#FF541C"/>
    <path d="M47.5454 31.616C49.5454 32.7707 49.5454 35.6574 47.5454 36.8121L29.8006 47.0571C27.8006 48.2118 25.3006 46.7684 25.3006 44.459L25.3006 23.9691C25.3006 21.6597 27.8006 20.2163 29.8006 21.371L47.5454 31.616Z" fill="white"/>
  </svg>
);

const getVideoId = (url) => {
  if (!url) return "";
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/))([-\w]+)/);
  return match ? match[1] : "";
};

const HeadstartSection = ({ data }) => {
  const [playing, setPlaying] = useState(false);
  const imgPath = process.env.REACT_APP_IMAGES;
  const [library, setLibrary] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_STATS_LIBRARY_JSON}?v=${Date.now()}`)
      .then((r) => r.ok ? r.json() : null)
      .then(setLibrary)
      .catch(() => {});
  }, []);

  if (!data) return null;

  const resolvedStats = library?.stats && data.stats?.length
    ? data.stats.map((stat) => {
        const s = stat.libraryId ? library.stats[stat.libraryId] : null;
        return s ? { value: s.value, label: stat.label } : stat;
      })
    : null;

  const videoId = getVideoId(data.videoUrl);

  return (
    <section className="headstart-section section-spacing">
      {/* Desktop stats - outside Container for full width */}
      {resolvedStats && (
        <div className="headstart-stats-bar headstart-stats-desktop">
          {resolvedStats.map((stat, i) => (
            <div className="headstart-stat" key={i}>
              <span className="headstart-stat-value">{parse(stat.value)}</span>
              <span className="headstart-stat-label">{parse(stat.label)}</span>
            </div>
          ))}
        </div>
      )}

      <Container fluid>
        {/* Mobile scrolling stats */}
        {resolvedStats && (
          <div className="headstart-stats-mobile">
            <div className="headstart-stats-track">
              {[...resolvedStats, ...resolvedStats].map((stat, i) => (
                <div className="headstart-stat" key={i}>
                  <span className="headstart-stat-value">{parse(stat.value)}</span>
                  <span className="headstart-stat-label">{parse(stat.label)}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="headstart-center">
          <div className="headstart-badge-row">
            <span className="headstart-badge-square" />
            <span className="headstart-badge">{parse(data.badge)}</span>
          </div>
          <h2 className="headstart-heading">{parse(data.heading)}</h2>

          <div className="headstart-video-wrapper video-glow">
            <span className="video-glow-blob-1" />
            <span className="video-glow-blob-2" />
            <div className="headstart-thumb-click" onClick={() => !playing && setPlaying(true)} role="button" tabIndex={0} aria-label="Play video">
              <img
                src={`${imgPath}${data.thumbnail}`}
                alt={data.badge}
                className="headstart-thumbnail"
                loading="lazy"
              />
              {!playing && (
                <span className="headstart-play-btn">
                  <PlayButton />
                </span>
              )}
              {playing && (
                <>
                  <div className="video-loading-spinner" />
                  <iframe
                    className="headstart-iframe video-iframe-overlay"
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                    title={data.badge}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    frameBorder="0"
                  />
                  <button className="headstart-close-btn" onClick={(e) => { e.stopPropagation(); setPlaying(false); }} aria-label="Close video">✕</button>
                </>
              )}
            </div>
          </div>

          {data.timeline && (
            <div className="headstart-timeline">
              <div className="headstart-timeline-line" />
              {data.timeline.map((item, i) => (
                <div className="headstart-timeline-item" key={i}>
                  <span className="headstart-timeline-year">{parse(item.year)}</span>
                  <img src={`${imgPath}hypnosis.gif`} alt="" className="headstart-timeline-gif" loading="lazy" />
                  <span className="headstart-timeline-desc">{parse(item.description)}</span>
                </div>
              ))}
            </div>
          )}

          {data.bottomQuote && (
            <p className="headstart-bottom-quote">{parse(data.bottomQuote)}</p>
          )}
        </div>
      </Container>
    </section>
  );
};

export default HeadstartSection;
